export type NavItem = {
  label: string;
  href: string;
};

export const mainNav: NavItem[] = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/fleet" },
  { label: "Contact Us", href: "/rates" },
  { label: "Terms & Conditions", href: "/booking" },
];

export const siteConfig = {
  name: "A & Jay Car Rental",
  tagline: "Reliable vehicles for every journey",
  copyrightYear: new Date().getFullYear(),
} as const;
